import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// Interface for image preview data
export interface ImagePreviewData {
	imageUrl: string;
	title: string;
	subtitle?: string;
	altText?: string;
}

@Component({
	selector: 'app-image-preview-modal',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './image-preview-modal.component.html',
	styleUrls: ['./image-preview-modal.component.scss'],
})
export class ImagePreviewModalComponent {
	// Services
	activeModal = inject(NgbActiveModal);

	// Component state - will be set when modal is opened
	imageData: ImagePreviewData | null = null;

	/**
	 * Set the image data to be displayed in the modal
	 * @param data Image preview data
	 */
	setImageData(data: ImagePreviewData): void {
		this.imageData = data;
	}

	/**
	 * Close the modal
	 */
	close(): void {
		this.activeModal.close();
	}

	/**
	 * Dismiss the modal
	 */
	dismiss(): void {
		this.activeModal.dismiss();
	}
}